import { render, staticRenderFns } from "./inviteSetting.vue?vue&type=template&id=a1a1c79a&scoped=true"
import script from "./inviteSetting.vue?vue&type=script&lang=js"
export * from "./inviteSetting.vue?vue&type=script&lang=js"
import style0 from "./inviteSetting.vue?vue&type=style&index=0&id=a1a1c79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a1c79a",
  null
  
)

export default component.exports